import React from "react";

import { useAnalyticsTracker } from "components/instrumentation/source/analytics";
import {
  Rating as RatingPFC,
  RatingProps as RatingPFCProps,
} from "components/ui/source/components/Rating/Rating";

interface RatingProps extends RatingPFCProps {
  listingId: string;
}

export const Rating = ({ average, listingId, total, ...rest }: RatingProps) => {
  const { analytics } = useAnalyticsTracker();
  return (
    <RatingPFC
      {...rest}
      average={average}
      total={total}
      onOpen={() =>
        analytics.track("Ratings Total Clicked", {
          listingId,
          rating_average: average,
          rating_reviews_total: total,
        })
      }
    />
  );
};
